import { withStyles } from '@material-ui/core';

import Option from './component';
import styles from './styles';

export default withStyles(styles)(Option);
